import * as React from "react"
import BasePage from "../../base-page"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ToolbarItem } from "../../toolbar"
import { Profile, getProfile } from "../../../domain/sfp/user-domain"
import { LocalAuthority, User, Instruction } from "../../../model"
import LocalAuthorityDetail from "../local-authority-detail-page"
import { isBergerLevraultEnabled } from "../../../domain/sfp/berger-levrault-domain"
import { SimpleModal } from "../../modal"
import "./style.scss"

export default class LocalAuthorityListComponent
extends BasePage<LocalAuthorityListComponentProps, State> {
	protected editingProfiles: Profile[] = this.props.editingProfiles
	protected viewingProfiles: Profile[] = this.props.viewProfiles
	protected toolbar?: ToolbarItem[] = this.getToolbarItems()
	private readonly name: string = "name"
	private readonly cog: string = "cog"
	private readonly connecteur: string = "connecteur"
	private readonly bergerLevrault: string = "Berger Levrault"
	private readonly dateImport: string = "dateimport"

	constructor(props){
		super(props)		

		this.state = {
			sortedColumn: {
				columnName: "cog",
				order: "asc"
			},
			showModalUpload: false,
			modalData: null,
		}
	}

	renderPageContent() {
		const currentUser = this.props.currentUser
		const currentUserProfile = currentUser ? getProfile(currentUser) : null
		const localAuthorities = this.sortLocalAuthorities()

		return <div>
			<table className="table is-narrow">
				<thead>
					<tr>
						<th className="button-header" onClick={() => this.changeColumn(this.cog)}>Code Officiel Géographique</th>
						<th className="button-header" onClick={() => this.changeColumn(this.name)}>Nom de collectivité</th>
						<th className="button-header"></th>
						<th className="button-header"></th>
						<th className="button-header" onClick={() => this.changeColumn(this.connecteur)}>Connecteur</th>
						<th className="button-header"></th>
						<th className="button-header"></th>
						<th className="button-header">Budget annexe</th>
						<th className="button-header" onClick={() => this.changeColumn(this.dateImport)}>Date du dernier import</th>
						{(Profile.LocalAuthorityConsultant !== currentUserProfile
						&& Profile.ServiceAgent !== currentUserProfile) &&
						[<th className="button-column" key={0}></th>,
						// <th className="button-column" key={1}></th>,
						]}
					</tr>
				</thead>
				<tbody>
					{localAuthorities && localAuthorities.length
					? localAuthorities.map((localAuthority, i) => {
						const loading = this.isLoadingLocalauthority(localAuthority)
						if (localAuthority.parentId)
							return <tr key={i}>
								<td>{localAuthority.code}</td>
								<td>{localAuthority.name}</td>
								<td> </td>
								<td></td>
								<td >
								<button
								className={`button is-small ${loading ? "is-loading" : ""}`}
								title={`Voir le détail de la collectivité ${localAuthority.name}`}
								onClick={() => this.props.onClickViewLocalAuthorityChild(localAuthority)}
								>
									<span className="icon is-small">
										<FontAwesomeIcon icon="eye" />
									</span>
								</button>
							    </td>

								<td >
								<button
								className={`button is-small ${loading ? "is-loading" : ""}`}
								title={`Voir le détail de la collectivité ${localAuthority.name}`}
								onClick={() => this.props.onClickDeleteLocalAuthorityChild(localAuthority)}
								>
									<span className="icon is-small">
									     <FontAwesomeIcon icon="trash-alt"/>
									</span>
								</button>
							    </td>
								<td >
								<button
								className={`button is-small ${loading ? "is-loading" : ""}`}
								title={`Voir le détail de la collectivité ${localAuthority.name}`}
								onClick={() => this.props.onClickEditChildLocalAuthority(localAuthority)}
								>
									<span className="icon is-small">
										<FontAwesomeIcon icon="pen-square" />
									</span>
								</button>
							    </td>								
							</tr>
						return <tr key={i}>
							<td>{localAuthority.code}</td>
							<td>{localAuthority.name}</td>
							<td>
								<button 
									className="button is-primary"
									onClick={() => this.props.onClickAddChildLocalAuthority(localAuthority)}
								>Ajouter un budget annexe</button>
							</td>
							<td>
								<button 
									className="button is-primary"
									onClick={() => this.showModalUpload(true, localAuthority)}>
										Importer le fichier Totem
								</button>
							</td>
							<td>{isBergerLevraultEnabled(localAuthority.bergerLevrault) ? this.bergerLevrault : ""}</td>
							{(Profile.LocalAuthorityConsultant !== currentUserProfile
							&& Profile.ServiceAgent !== currentUserProfile) &&
							[<td key={0}>
								<button
								className={`button is-small ${loading ? "is-loading" : ""}`}
								title={`Voir le détail de la collectivité ${localAuthority.name}`}
								onClick={() => this.props.onClickViewLocalAuthority(localAuthority)}>
									<span className="icon is-small">
										<FontAwesomeIcon icon="eye" />
									</span>
								</button>
							</td>,
							// <td key={1}>
							// 	<button
							// 	className={`button is-danger is-outlined is-small ${loading ? "is-loading" : ""}`}
							// 	title={`Supprimer ${fullName}`}
							// 	onClick={() => this.props.onDeleteUser(user)}>
							// 		<span className="icon is-small">
							// 			<FontAwesomeIcon icon="trash" />
							// 		</span>
							// 	</button>
							// </td>
						]}
						<td>
							{this.renderButton(localAuthority)}
						</td>
						<td></td>
						<td>
							{localAuthority.lastImportDate ? new Date(localAuthority.lastImportDate).toLocaleDateString() : ''}
						</td>
						</tr>})
					: <tr><td colSpan={5}>Aucune collectivité enregistrée</td></tr>}
				</tbody>
			</table>

			{this.state.showModalUpload && this.renderModal()}

			{this.props.addChildLocalAuthority &&
			<LocalAuthorityDetail
			isChild={true}
			localAuthority={this.props.localAuthority}
			instructions={this.props.instructions}
			loadingInstructions={this.props.loadingInstructions}
			onClose={this.props.onCloseAddChildLocalAuthority}
			onLocalChildAuthorityCreated={(l)=>this.props.onLocalChildAuthorityCreated(l)} />}


			{this.props.addLocalAuthority &&
			<LocalAuthorityDetail
			instructions={this.props.instructions}
			loadingInstructions={this.props.loadingInstructions}
			onClose={this.props.onCloseAddLocalAuthority}
			onLocalAuthorityCreated={this.props.onLocalAuthorityCreated} />}

			{this.props.viewLocalAuthority &&
			<LocalAuthorityDetail
			localAuthority={this.props.localAuthority}
			onClose={this.props.onCloseEditLocalAuthority}
			onLocalAuthorityUpdated={this.props.onLocalAuthorityUpdated}
			updatePA={(l)=>this.props.onLocalAuthorityUpdatedPA(l)} />}

            {this.props.editExtraLocalAuthority &&
			<LocalAuthorityDetail
			editExtraLocalAuthority={true}
			localAuthority={this.props.localAuthority}
			onClose={this.props.onCloseEditExtraChildLocalAuthority}
			onLocalAuthorityExtraChidEdited={(l)=>this.props.onLocalAuthorityExtraChidEdited(l)}
			updatePA={(l)=>this.props.onLocalAuthorityUpdatedPA(l)} />}

		</div>
	}


	private renderButton(localAuthority: LocalAuthority): React.ReactNode {
		const loading = this.isLoadingLocalauthority(localAuthority)
		if (localAuthority.slug === this.props.selectedSlug && this.props.viewingLocalAuthoritiesChildren)
			return <button
				className={`button is-small ${loading ? "is-loading" : ""}`}
				title={`Voir le détail de la collectivité ${localAuthority.name}`}
				>
					<span className="icon is-small">
						...
					</span>
				</button>
		if (localAuthority.slug === this.props.selectedSlug)
			return <button
				className={`button is-small ${loading ? "is-loading" : ""}`}
				title={`Voir le détail de la collectivité ${localAuthority.name}`}
				onClick={() => this.props.onCloseViewLocalChildAuthority()}
				>
					<span className="icon is-small">
						<FontAwesomeIcon icon="chevron-up"/>
					</span>
				</button>
		else 
			return <button
				className={`button is-small ${loading ? "is-loading" : ""}`}
				title={`Voir le détail de la collectivité ${localAuthority.name}`}
				onClick={() => this.props.onClickViewLocalChildAuthority(localAuthority)}
				>
					<span className="icon is-small">
						<FontAwesomeIcon icon="chevron-down"/>
					</span>
				</button>
	}

	private changeColumn(columnName: string): void {
		let order, newSortedColumn
		const actualSortedColumn = this.state.sortedColumn
		const orderAsc = actualSortedColumn.order === 'asc' ? order = 'desc' : order = 'asc'
		actualSortedColumn.columnName === columnName && actualSortedColumn.order === order ? order = !order : orderAsc
		newSortedColumn = {	columnName, order }
		this.setState({ sortedColumn: newSortedColumn })
	}



	private getToolbarItems(): ToolbarItem[] {
		const items: ToolbarItem[] = []
		items.push({
			allowedProfiles: [
				Profile.SuperAdmin,
				Profile.RegionAdmin,
				Profile.LocalAuthorityAdmin
			],
			icon: "user-plus",
			text: "Ajouter une collectivité",
			title: "Ajouter une collectivité",
			onClick: this.props.onClickAddLocalAuthority
		})
		return items
	}

	private sortLocalAuthorities() {
		let users
		const sortedColumn = this.state.sortedColumn
		const columnName = sortedColumn.columnName
		if (columnName === this.name) users = this.filteringName()
		if (columnName === this.cog) users = this.filteringCog()
		if (columnName === this.dateImport) users = this.filteringDateImport()
		if (this.props.selectedSlug) users = this.addChildren(users)
		return users
	}

	private filteringName() {
		const localAuthorities = this.props.localAuthorities
		const sortedColumn = this.state.sortedColumn
		let filtering = sortedColumn.order === 'asc' ? 1 : -1

		let sortedLocalauthorities = localAuthorities.filter((l, index) => localAuthorities.lastIndexOf(l) === index)
				.sort((a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1) * filtering)
		return sortedLocalauthorities
	}

	private filteringCog() {
		const localAuthorities = this.props.localAuthorities
		const sortedColumn = this.state.sortedColumn
		let filtering = sortedColumn.order === 'asc' ? 1 : -1

		let sortedLocalauthorities = localAuthorities.filter((l, index) => localAuthorities.lastIndexOf(l) === index)
			.sort((a, b) => (a.code < b.code ? -1 : 1) * filtering)
		return sortedLocalauthorities
	}

	private filteringDateImport() {
		const localAuthorities = this.props.localAuthorities
		const sortedColumn = this.state.sortedColumn
		let filtering = sortedColumn.order === 'asc' ? 1 : -1

		let sortedLocalauthorities = localAuthorities
		.filter((l, index) => localAuthorities.lastIndexOf(l) === index)
		.sort((a, b) => {
			// Si 'lastImportDate' est null ou undefined, on les place à la fin de la liste
			const dateA = a.lastImportDate ? new Date(a.lastImportDate).getTime() : 0;
			const dateB = b.lastImportDate ? new Date(b.lastImportDate).getTime() : 0;
			return (dateA < dateB ? -1 : 1) * filtering;
		});
		return sortedLocalauthorities
	}


	private addChildren(users) {
		let index = users.findIndex((user) => user.slug === this.props.selectedSlug)
		let children = this.props.localAuthoritiesChildren.map(child => ({ ...child, parentId: users[index]&& users[index].id,parentSlug: users[index]&& users[index].slug }));
		users.splice(index + 1, 0, ...children);
		return users;
	}

	private isLoadingLocalauthority(localAuthority: LocalAuthority) {
		return !!this.props.editingLocalAuthorities.find(l => l.id === localAuthority.id) || false
	}

	showModalUpload(show: boolean, localAuthority?: any){
		this.setState({ showModalUpload: show, modalData: localAuthority });
	}

	private renderModal(): React.ReactNode {
		const { showModalUpload, modalData } = this.state;
		return <SimpleModal
			active
			onClickCloseButton={() => this.showModalUpload(false)}
			clickable={false}
		>
			<div className="modalContainer">
				<p className="title">{ modalData.name }</p>
				<div className="popUpContainer">
					<div>
						{" "}
						<input type="file" onChange={(e) => this.props.handleFile(e)} />
					</div>
					<div className="d-flex">
						<button className="button is-primary" disabled={this.props.isLoadingFileValidation} onClick={() => this.props.uploadFile(modalData, true)}>
							Valider le fichier
							{ this.props.isLoadingFileValidation ? (
								<span className="bloc-center ml-10px">
									<FontAwesomeIcon icon="spinner" pulse />
								</span>
							) : ("")
						}
						</button>
						<button className="button is-primary ml-20px" disabled={this.props.isLoadingFile} onClick={() => this.props.uploadFile(modalData)}>
							Importer
							{ this.props.isLoadingFile ? (
								<span className="bloc-center ml-10px">
									<FontAwesomeIcon icon="spinner" pulse />
								</span>
							) : ("")
						}
						</button>
					</div>
				</div>
			</div>
			<span className={this.props.errorUpload ? "error" : "success"}>{this.props.messageUpload}</span>

			{ (this.props.messageValidation && this.props.messageValidation.length > 0)  ?
			(
				<div>
					<p className="error my-1">Les comptes suivants n'existent pas :</p>
					<ul>
						{this.props.messageValidation.map((message, index) => (
						<li key={index}>{message}</li>
						))}
					</ul>
				</div>
				
			) : ("")
			}
			{ (this.props.messageValidation && this.props.messageValidation.length == 0)  ?
			(
				<p className="success my-1">Le fichier est valide</p>
			) : ("")
			}
		</SimpleModal>
	}

}


interface State {
	sortedColumn: {
		columnName: "name" | "cog" | "dateImport",
		order: "asc" | "desc"
	},
	showModalUpload: boolean;
	modalData: any;
}

export enum Names {
	Name = "local-authority-list-name",
	Cog = "local-authority-list-cog",
	DateImport = "local-authority-list-dateImport",
}

export interface LocalAuthorityListComponentProps {
	selectedSlug: string
	addChildLocalAuthority: boolean
	addLocalAuthority: boolean
	currentUser: User
	editingLocalAuthorities: LocalAuthority[]
	editingProfiles: Profile[]
	instructions: Instruction[]
	loading: boolean
	loadingInstructions: boolean
	localAuthorities: LocalAuthority[]
	currentLocalAuthority: LocalAuthority
	localAuthoritiesChildren: LocalAuthority[]
	localAuthority: LocalAuthority
	viewLocalAuthority: boolean
	editExtraLocalAuthority: boolean
	viewProfiles: Profile[]
	viewingLocalAuthoritiesChildren: boolean
	isLoadingFile: boolean
	isLoadingFileValidation: boolean
	errorUpload: boolean
	messageUpload: string
	messageValidation: string[] | null
 
	onClickAddChildLocalAuthority(localAuthority: LocalAuthority): void
	onClickAddLocalAuthority(e: React.SyntheticEvent<Element>): void
	onClickViewLocalAuthority(localAuthority: LocalAuthority): void
	onClickDeleteLocalAuthorityChild(localAuthority: LocalAuthority): void
	onCloseAddLocalAuthority(): void
	onCloseEditLocalAuthority(): void
	onCloseEditExtraChildLocalAuthority(): void
	onLocalAuthorityCreated(): void
	onLocalAuthorityUpdated(): void
	onLocalAuthorityExtraChidEdited(localAuthority: LocalAuthority): void
	onLocalAuthorityUpdatedPA(localAuthority: LocalAuthority): void
	onClickViewLocalAuthorityChild(localAuthority: LocalAuthority): void
	onCloseAddChildLocalAuthority(): void
	onLocalChildAuthorityCreated(localAuthority: LocalAuthority): void
	onLocalExtraChildAuthorityCreated(): void
	onClickViewLocalChildAuthority(localAuthority: LocalAuthority): void
	onClickEditChildLocalAuthority(localAuthority: LocalAuthority): void
	onCloseViewLocalChildAuthority(): void
	handleFile(e: React.SyntheticEvent<Element>): void;
	uploadFile(localAuthority: LocalAuthority, validation?: boolean): void;

}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-list-page/local-authority-list-component.tsx